import React from "react";

//Styles
import "./styles.scss";

const Button = ({
  title = "Button",
  buttonStyle = {},
  titleStlye = {},
  onClick = () => {},
  forForm = false,
  forFormBtnType = 'submit'
}) => {
  return (
    <>
      {forForm ? (
        <button type={forFormBtnType} className="button" style={buttonStyle}>
          <p className="title" style={titleStlye}>
            {title}
          </p>
        </button>
      ) : (
        <div onClick={onClick} className="button" style={buttonStyle}>
          <p className="title" style={titleStlye}>
            {title}
          </p>
        </div>
      )}
    </>
  );
};

export default Button;
